import React, {useEffect, useState} from "react";
import IconPopupMinus from "../../Icons/IconPopupMinus";
import IconPopupPlus from "../../Icons/IconPopupPlus";

const ParticipantEntry = (props) => {

  const [val, setVal] = useState();

  const {
    onChange,
    value,
    label,
    description
  } = props;

  useEffect(() => {
    setVal(value);
  }, [value]);

  const increase = () => {
    const newVal = val + 1;
    setVal(newVal);
    if (onChange) {
      onChange(newVal)
    }
  }

  const decrease = () => {
    const newVal = (val - 1) > 0 ? (val - 1) : 0
    setVal(newVal);
    if (onChange) {
      onChange(newVal)
    }
  }

  return <div className="passengerPopup__item__wrap">
    <div className="passengerPopup__item">
      <div className="passengerPopup__item__left">
        <p>{label}</p>
        <p>{description}</p>
      </div>
      <div className="passengerPopup__item__right">
        <div className="passengerPopup__item__counter">
          <div className="item__reduce item__action" onClick={decrease}>
            <IconPopupMinus />
          </div>
          <div className="passengerPopup__item__count__wrap">
            <div className="passengerPopup__item__count">
              <input
                min={0}
                aria-labelledby="item__count"
                value={val}
                onChange={(e) => {
                  setVal(e.target.value);
                  if (onChange) {
                    onChange(e.target.value);
                  }
                }}
              />
            </div>
          </div>

          <div className="passengerPopup__item__increase item__action" onClick={increase}>
            <IconPopupPlus />
          </div>
        </div>
      </div>
    </div>
  </div>

}

export default ParticipantEntry;
